import { UnwatchLinkStyled, UnwatchWrapperStyled } from 'components/Blocks/Product/Unwatch/Unwatch.style';
import useTranslation from 'next-translate/useTranslation';

type UnwatchProps = {
    onUnwatch: () => void;
};

const Unwatch: FC<UnwatchProps> = ({ onUnwatch }) => {
    const { t } = useTranslation();

    return (
        <UnwatchWrapperStyled>
            <UnwatchLinkStyled onClick={onUnwatch}>{t('Cancel watch')}</UnwatchLinkStyled>
        </UnwatchWrapperStyled>
    );
};

export default Unwatch;
